import React from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, Briefcase, FileText, MessageSquare, Megaphone, Star, Mail, Inbox, Receipt, BellRing, ArrowUpRight } from "lucide-react";
import { formatDateTime } from "@/lib/datetime";

const ICONS = { order: ShoppingBag, job: Briefcase, enquiry: Inbox, quote: FileText, invoice: Receipt, conversation: MessageSquare,
  campaign: Megaphone, review: Star, review_request: BellRing, subscription: Mail };
const gbp = (v) => (v == null ? "–" : `£${Number(v).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
export { gbp };

export const Card = ({ title, icon: Icon, children, testid, right }) => (
  <section className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5" data-testid={testid}>
    <div className="flex items-center justify-between mb-3">
      <h2 className="text-base font-bold text-slate-900 flex items-center gap-2">{Icon && <Icon className="w-4 h-4 text-indigo-500" />}{title}</h2>
      {right}
    </div>
    {children}
  </section>
);

export const LinkedBy = ({ v }) => v ? (
  <span className={`text-[10px] font-semibold uppercase tracking-wide rounded px-1.5 py-0.5 ${v === "name" ? "bg-amber-50 text-amber-700" : "bg-slate-100 text-slate-500"}`}
    title={v === "name" ? "Linked by exact customer name only" : `Linked by ${v}`}>{v === "name" ? "name match" : v}</span>
) : null;

export const Open = ({ to, testid }) => to ? (
  <Link to={to} className="inline-flex items-center gap-0.5 text-xs font-medium text-indigo-600 hover:text-indigo-800" data-testid={testid}>Open <ArrowUpRight className="w-3 h-3" /></Link>
) : null;

export function Timeline({ items }) {
  if (!items.length) return <p className="text-sm text-slate-400" data-testid="analytics-timeline-empty">No recorded activity yet.</p>;
  return (
    <ol className="relative border-l border-slate-200 ml-2 space-y-4 max-h-[560px] overflow-y-auto pr-1" data-testid="analytics-timeline">
      {items.map((e, i) => {
        const Icon = ICONS[e.type] || Briefcase;
        return (
          <li key={i} className="ml-5" data-testid={`analytics-timeline-item-${i}`}>
            <span className="absolute -left-[11px] flex items-center justify-center w-5 h-5 rounded-full bg-white border border-slate-200"><Icon className="w-3 h-3 text-indigo-500" /></span>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="text-sm font-medium text-slate-800 break-words">{e.title}</div>
                {e.detail && <div className="text-xs text-slate-500 break-words">{e.detail}</div>}
                <div className="flex items-center gap-2 mt-0.5 text-[11px] text-slate-400">{formatDateTime(e.at)} <LinkedBy v={e.linked_by} /></div>
              </div>
              <Open to={e.link} testid={`analytics-timeline-open-${i}`} />
            </div>
          </li>
        );
      })}
    </ol>
  );
}
